import React, {PureComponent} from 'react'
import StyleSheet from 'styles'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import PageviewIcon from '@material-ui/icons/Pageview'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'

export class MarkDownField extends PureComponent {

  render = () => {
    const {onRequestOpenPreview, onRequestOpenHelp, showPreviewButton, showHelpButton, value, onChange, ...attributes} = this.props
    const requestPreview = onRequestOpenPreview ? onRequestOpenPreview : () => {}
    const requestHelp = onRequestOpenHelp ? onRequestOpenHelp : () => {}

    return (
      <div>
        <TextField
          multiline rows={5} rowsMax={15}
          value={value} onChange={onChange}
          inputProps={{className: styles.markDownField}}
          InputLabelProps={{shrink: true}}
          fullWidth
          {...attributes}
        />

        {showPreviewButton &&
          <Button onClick={requestPreview} color="primary" aria-label="Preview">
            Preview
            <PageviewIcon className={styles.rightIcon}/>
          </Button>
        }
        {showHelpButton &&
        <Button onClick={requestHelp} color="primary" aria-label="Preview">
          Help
          <HelpOutlineIcon className={styles.rightIcon}/>
        </Button>
        }
      </div>
    )
  }
}

const styles = StyleSheet({
  markDownField: {
    fontFamily: 'Consolas,"Liberation Mono",Courier,monospace',
    fontSize: '14px',
    fontWeight: '400',
    fontStyle: 'normal',
    backgroundColor: 'white',
    color: 'rgba(0, 0, 0, 0.75)',
  },
  rightIcon: {
    paddingLeft: '8px'
  }
})